// extracted by mini-css-extract-plugin
export var postsGrid = "Blog-module--posts-grid--098T1";